/** *****************************************************************************
 * @license
 * Copyright (c) 2016 - present Accedo. All Rights Reserved.
 *
 * This source code, its use, and distribution, is subject to the terms
 * and conditions of the applicable license agreement.
 *
 * Accedo Build XDK players modules (@accedo/xdk-players-contrib) 4.1.11
 *
 ****************************************************************************** */
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import shakaPlayer from 'shaka-player/dist/shaka-player.compiled.debug';
import {
  klass,
  MediaConstants,
  PlayerConstants,
  Environment
} from '@accedo/xdk-core';
import { HTML5Player } from '@accedo/xdk-base-modules';
import logger from '@accedo/xdk-log';
import ShakaErrorMap from '@accedo/xdk-players-contrib/esm/players/shaka/ShakaErrorMap';
import { ID } from '@accedo/xdk-players-contrib/esm/players/shaka/id';
import { PlayerConfig } from '@accedo/xdk-config';

const { logError: err, debug } = logger({ logTag: `[${ID}]` });
const {
  DRM: { CLEARKEY, PLAYREADY, WIDEVINE },
  PROTOCOL: { DASH, HLS, PROGRESSIVE }
} = MediaConstants;
const {
  EVENT: { ERROR }
} = PlayerConstants;
const sEnv = Environment.singleton();
const handleShakaException = a => {
  const { code: e } = a;
  sEnv.dispatchEvent(ERROR, {
    shakaError: e,
    xdkError: ShakaErrorMap.get(e)
  });
  err(
    `Error on load method with Shaka code: ${e}. Please visit\n        https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html#:~:text=${e}\n        for more info`
  );
};
const ShakaPlayer = klass.create(
  HTML5Player,
  {},
  {
    __id: 'shakaplayer',
    init(a = {}, e = {}) {
      this._super(a, e);
      this._extensionManager = e;
      try {
        shakaPlayer.polyfill.installAll();
      } catch (error) {
        handleShakaException(error);
      }
    },
    getCapabilities: () => ({
      protocol: [DASH, HLS, PROGRESSIVE],
      drm: [CLEARKEY, PLAYREADY, WIDEVINE]
    }),
    prepare(a = {}) {
      const e = {};
      const { config: r = {} } = a;
      const { config: t = {} } = this._playerConfig;
      _Object$assign(e, r, t);
      this._super(a);
      try {
        console.debug(
          `[DEBUG] Shaka player version ${shakaPlayer.Player.version}`
        );
        this._shaka = new shakaPlayer.Player(this._playerObject);
        this._shaka.configure(e);
      } catch (error) {
        handleShakaException(error);
      }
    },
    async load(a, e) {
      const { drm: r, parentNode: t, requestInterceptor: o } = e;
      if (
        (o && this._shaka.getNetworkingEngine().registerRequestFilter(o),
        t && this._preparePlayerObject(t),
        r)
      ) {
        const extDrm = await this._extensionManager.getExtension('drm');
        const drmAgent = await extDrm.createDRMAgent(r);
        await drmAgent.prepare(e, this);
      }
      try {
        // [BUG] Causes shaka to crash
        // await this._shaka.unload();
        shakaPlayer.Player.probeSupport();
        await this._shaka.load(a);
      } catch (error) {
        handleShakaException(error);
      }
    },
    getPlayerObject() {
      return this._shaka;
    }
  }
);
export default ShakaPlayer;
export const shaka = new PlayerConfig({
  id: ID,
  config: {},
  importer: () => Promise.resolve({ default: ShakaPlayer })
});
